var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinimunOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6003",
    "data-name": "Group 6003",
    transform: "translate(-1146 -675)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(1146 675)",
    fill: "#eef4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shipping",
    transform: "translate(1163.287 693.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7132",
    "data-name": "Path 7132",
    d: "M28.1,38.768H22.133A2.133,2.133,0,0,1,20,36.636v-14.5A2.133,2.133,0,0,1,22.133,20H33.055",
    transform: "translate(-20 -20)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_315",
    "data-name": "Ellipse 315",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(11.712 11.972)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7133",
    "data-name": "Path 7133",
    d: "M345.238,334.133v0l-1.507,1.507",
    transform: "translate(-326.999 -315.533)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7134",
    "data-name": "Path 7134",
    d: "M148.583,28.1V22.133A2.133,2.133,0,0,0,146.451,20H142.4v6.4l-.833-.555a4.265,4.265,0,0,0-4.732,0L136,26.4V20",
    transform: "translate(-129.815 -20)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimunOrder);
export default __webpack_public_path__ + "static/media/MinimunOrder.067c30ea26010d0aadcb1778b9f587d3.svg";
export { ForwardRef as ReactComponent };